import React from 'react'

// Constants
import { RouteProps, routes } from 'constants/routes'
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'

// Utils
import { useQueryParams } from 'utils'

// Components
import SignInForm from 'components/SignInForm'
import IndexLayout, { Title } from 'components/IndexLayout'
import RedirectBadge from 'components/RedirectBadge'
import Button from 'components/Button'
import OrderedBreadcrumbs from 'components/OrderedBreadcrumbs'
import { useModalContext } from 'containers/ModalManager/ModalContext'
import SketchLoginDeprecationModal from '../../modals/SketchLoginDeprecationModal'

// Styles
import {
  BreadcrumbsWrapper,
  BottomSection,
  BottomTitle,
  BottomDescription,
  Line,
  StyledLinkButton,
  Columns,
} from './SignInView.styles'
import { Location } from 'history'

const SIGN_IN_CRUMBS = [{ content: 'Sign In' }, { content: 'Create Workspace' }]
interface LocationState {
  from: Location
}
interface SignInViewProps extends RouteProps<'SIGN_IN'> {
  location: Location<LocationState>
}

const SignInView: React.FC<SignInViewProps> = ({ history, location }) => {
  const { state } = location

  const { showModal } = useModalContext()

  const queryParams = useQueryParams<'SIGN_IN'>()
  const linkState = { from: state?.from }

  const willContinueToWorkspaceCreation =
    state?.from?.pathname === routes.WORKSPACE_CREATE.create({})

  return (
    <IndexLayout headerLink="sign-up" variant="teal">
      {state?.from && <RedirectBadge from={state.from} />}

      {willContinueToWorkspaceCreation && (
        <BreadcrumbsWrapper>
          <OrderedBreadcrumbs crumbs={SIGN_IN_CRUMBS} currentCrumb={0} />
        </BreadcrumbsWrapper>
      )}
      <Title>Sign in to Sketch</Title>
      <SignInForm
        onCompleted={() => {
          if (queryParams.sketch === 'true') {
            showModal(SketchLoginDeprecationModal)
          }

          if (willContinueToWorkspaceCreation) {
            history.push(routes.WORKSPACE_CREATE.create({}), {
              fromSignIn: true,
            })
          } else {
            history.push(state?.from || routes.ENTRY.create({}))
          }
        }}
      />
      <Line />
      <StyledLinkButton
        smaller
        variant="secondary-untinted"
        to={{
          pathname: routes.SSO_SIGN_IN.create({}),
          state: linkState,
        }}>
        Sign in with SSO
      </StyledLinkButton>
      <BottomSection>
        <BottomTitle>Using Sketch with a License?</BottomTitle>
        <Columns>
          <BottomDescription>
            As a Legacy License user you won’t have a Workspace to sign into but
            you can switch your license to a subscription
          </BottomDescription>
          <Button
            variant="secondary-untinted"
            target="_blank"
            href={`${SKETCH_WEBSITE}/support/license-manager`}
            rel="noopener noreferrer"
            as="a"
            smaller>
            Learn More...
          </Button>
        </Columns>
      </BottomSection>
    </IndexLayout>
  )
}

export default SignInView
